import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MyprofileRoutingModule } from './myprofile-routing.module';
import { MyprofileComponent } from './myprofile.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatDialogModule } from '@angular/material';
import { NgOtpInputModule } from 'ng-otp-input';
import { RegisterModule } from 'app/pages/content-layout-page/register/register.module';
import { OtpVerificationModule } from 'app/pages/content-layout-page/register/otpverification/otpverificaation.module';

@NgModule({
  declarations: [
    MyprofileComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    MyprofileRoutingModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SharedModule,
    ReactiveFormsModule,
    RecaptchaModule,
    NgOtpInputModule,
    MatDialogModule,
    RegisterModule,
    OtpVerificationModule
  ]
})
export class MyprofileModule { }
